import React from "react"
import { ExtratoPixFornecedorContextProvider } from "./context/ExtratoPixFornecedorContextProvider"
import { ExtratoPixFornecedor } from "./ExtratoPixFornecedor"

export function Index() {
    return (
        <ExtratoPixFornecedorContextProvider>
            <ExtratoPixFornecedor />
        </ExtratoPixFornecedorContextProvider>
    )
}
